import React, {useState} from "react";
import S, {C} from "../styles";
import {apiCreateInvite} from "../api/invites";
import {buildInviteEmailText, buildInviteLink} from "../utils";
import Modal from "./Modal";

const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

// Le contenu du dialogue vit dans son propre composant : monté/démonté avec la
// modale, son état repart de zéro à chaque ouverture sans reset manuel.
function InviteDialog({selectedGroup, onClose}) {
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");
    const [link, setLink] = useState("");
    const [copyStatus, setCopyStatus] = useState("idle"); // "idle" | "ok" | "fail"

    const emailValid = EMAIL_REGEX.test(email);

    async function sendInvite() {
        if (!emailValid || sending) return;
        setSending(true);
        setError("");
        const data = await apiCreateInvite(selectedGroup.id);
        setSending(false);
        if (data.error) { setError(data.error); return; }

        const inviteLink = buildInviteLink(data.token);
        setLink(inviteLink);
        const {subject, body} = buildInviteEmailText(data.group_name, inviteLink);
        window.location.href =
            `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }

    function copyLink() {
        navigator.clipboard.writeText(link)
            .then(() => setCopyStatus("ok"))
            .catch(() => setCopyStatus("fail"));
    }

    return (
        <Modal title="✉️ Inviter un.e collègue" onClose={onClose}>
            <p style={{fontSize: 13, color: C.textMuted, marginBottom: 14, lineHeight: "19px"}}>
                Invitez un.e collègue à rejoindre <strong>{selectedGroup.name}</strong> sur Paroles d'Agents.
            </p>

            <input
                type="email"
                autoFocus
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email du.de la collègue"
                style={{
                    width: "100%", padding: "9px 12px", marginBottom: 10,
                    borderRadius: 10, border: `1.5px solid ${C.border}`, boxSizing: "border-box",
                    fontSize: 14, color: C.text, fontFamily: "inherit",
                }}
            />

            {error && <p style={{color: C.danger, fontSize: 13, marginBottom: 8, marginTop: -4}}>{error}</p>}

            <button
                onClick={sendInvite}
                disabled={!emailValid || sending}
                style={{
                    ...S.primaryButton,
                    width: "100%",
                    opacity: (!emailValid || sending) ? 0.6 : 1,
                }}
            >
                {sending ? "Génération…" : "Envoyer l'invitation"}
            </button>

            {link && (
                <div style={{marginTop: 14, padding: 12, backgroundColor: C.bg, borderRadius: 8}}>
                    <p style={{fontSize: 14, fontWeight: 700, color: C.primary, margin: "0 0 6px"}}>
                        ✅ Lien d'invitation généré
                    </p>
                    <p style={{fontSize: 12, color: C.textMuted, margin: "0 0 6px", lineHeight: "17px"}}>
                        Votre messagerie a dû s'ouvrir avec un message pré-rempli : il ne vous reste plus qu'à l'envoyer.
                        Si rien ne s'est ouvert, copiez le lien ci-dessous et collez-le dans un email (ou un message)
                        à votre collègue pour qu'il/elle puisse rejoindre le collectif.
                    </p>
                    <input
                        readOnly value={link}
                        onClick={e => e.target.select()}
                        style={{
                            width: "100%", padding: "7px 10px", borderRadius: 8,
                            border: `1px solid ${C.border}`, boxSizing: "border-box",
                            fontSize: 12, color: C.text, marginBottom: 8,
                        }}
                    />
                    <button
                        onClick={copyLink}
                        style={{...S.button, width: "100%", marginRight: 0, marginBottom: 0}}
                    >
                        {copyStatus === "ok" ? "Copié !"
                            : copyStatus === "fail" ? "Copie impossible — sélectionnez le lien ci-dessus"
                            : "Copier le lien"}
                    </button>
                </div>
            )}
        </Modal>
    );
}

export default function InviteColleagueButton({selectedGroup}) {
    const [open, setOpen] = useState(false);

    if (!selectedGroup) return null;

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                style={{
                    backgroundColor: C.accent,
                    color: C.primaryDark,
                    border: "none",
                    borderRadius: 50,
                    padding: "8px 18px",
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                }}
            >
                ✉️ Inviter un.e collègue
            </button>

            {open && <InviteDialog selectedGroup={selectedGroup} onClose={() => setOpen(false)} />}
        </>
    );
}
